import script from "./trash.vue?vue&type=script&lang=ts&setup=true"
export * from "./trash.vue?vue&type=script&lang=ts&setup=true"

import "./trash.vue?vue&type=style&index=0&id=f553d89a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f553d89a"]])

export default __exports__